import {ModalBody} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import SelectedCard from "../methaphoricCards/SelectedCard";
import {metaphoricCardAuthors} from "../methaphoricCards/DefaultMetaphoricCards";
import {useTranslation} from "react-i18next";

export default function SelectedMetaphoricCardsModal(props) {
    const { i18n } = useTranslation();
    return (
        <>
            <Modal
                show={true}
                onHide={props.closeModal}
            >
                <ModalBody>
                    <SelectedCard
                        selectedCardClassName={"default"}
                        selectedCardlink={props.cardLink}
                        allowShare={props.allowShare}
                        selectedStackData={
                            {
                                author_link:metaphoricCardAuthors[props.deckId].link,
                                author_name_ua: metaphoricCardAuthors[props.deckId].name,
                                author_name_en: metaphoricCardAuthors[props.deckId].name_en,
                                author_name:i18n.language === "en" ? metaphoricCardAuthors[props.deckId].name_en : metaphoricCardAuthors[props.deckId].name,
                                deck_id:props.deckId
                            }
                    }
                    />
                </ModalBody>
            </Modal>
        </>
    )
}